import React from 'react';
import { Typography, Button, Box } from '@mui/material';
import { Inbox } from 'lucide-react';

/**
 * EmptyState - Consistent empty/no-data state component
 */
export default function EmptyState({
  icon: Icon = Inbox,
  title = 'No data found',
  message = 'There are no items to display.',
  actionText,
  onAction,
  className = '',
}) {
  return (
    <Box
      className={`flex flex-col items-center justify-center py-16 px-6 text-center ${className}`}
    >
      <div
        className="flex items-center justify-center rounded-2xl mb-4"
        style={{
          width: 64,
          height: 64,
          background: 'var(--gradient-subtle)',
        }}
      >
        <Icon size={28} style={{ color: 'var(--accent-primary)' }} />
      </div>
      <Typography
        variant="h6"
        sx={{ color: 'var(--text-primary)', fontWeight: 600, mb: 1 }}
      >
        {title}
      </Typography>
      <Typography
        variant="body2"
        sx={{ color: 'var(--text-muted)', maxWidth: 320, mb: actionText ? 3 : 0 }}
      >
        {message}
      </Typography>
      {actionText && onAction && (
        <Button variant="contained" onClick={onAction}>
          {actionText}
        </Button>
      )}
    </Box>
  );
}
